import React, { createContext, useContext, useEffect, useMemo, useState } from "react"

const ThemeContext = createContext(null)

const STORAGE_KEY = "astudent-theme"

const applyThemeToDom = (mode) => {
  const root = document.documentElement
  const isDark = mode === "dark"

  root.classList.toggle("dark", isDark)
  root.setAttribute("data-theme", isDark ? "dark" : "astudent")
}

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState("light")

  useEffect(() => {
    const saved = window.localStorage.getItem(STORAGE_KEY)
    const initial = saved === "dark" ? "dark" : "light"
    setMode(initial)
    applyThemeToDom(initial)
  }, [])

  const value = useMemo(() => {
    return {
      mode,
      setMode: (next) => {
        const normalized = next === "dark" ? "dark" : "light"
        setMode(normalized)
        window.localStorage.setItem(STORAGE_KEY, normalized)
        applyThemeToDom(normalized)
      },
      toggle: () => {
        const next = mode === "dark" ? "light" : "dark"
        setMode(next)
        window.localStorage.setItem(STORAGE_KEY, next)
        applyThemeToDom(next)
      },
    }
  }, [mode])

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

export const useTheme = () => {
  const ctx = useContext(ThemeContext)
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider")
  return ctx
}

